import React from 'react'

class Gallery extends React.Component {
  render () {
    return (
      <>
        <section className='our-speaker-area bg-img bg-gradient-overlay section-padding-100-60' style={{ backgroundImage: 'url(/img/bg-img/3.jpg)' }}>
          <div className='container'>
            <div className='row'>
              {/* <!-- Heading --> */}
              <div className='col-12'>
                <div className='section-heading text-center wow fadeInUp' data-wow-delay='300ms'>
                  <p>RoboChef Gallery</p>
                  <h4>RoboChef and It's Journey</h4>
                </div>
              </div>
            </div>

            
            <div className='row'>
              {/* <!-- Single Speaker Area --> */}
              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef.jpeg' alt='' />
                  </div>
                  {/* <!-- Social Info --> */}
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>RoboChef</h5>
                    <p>The Robotic Kitchen</p>
                  </div>
                </div>
              </div>

              {/* <!-- Single Speaker Area --> */}
              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robovel.jpeg' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>Best Product Demo Award</h5>
                    <p>SAI Event</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/team.jpeg' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>The Team</h5>
                    <p>RoboChef</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-dina.jpeg' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>Dinamalar News Paper</h5>
                    <p>Media</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-ie.png' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>The New Indian Express</h5>
                    <p>Media</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-hindu.png' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>The Hindu</h5>
                    <p>Media</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-poli.png' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>Polimer News</h5>
                    <p>Tv & Media</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-vendhar.png' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>Vendhar Tv</h5>
                    <p>Tv & Media</p>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-6 col-lg-4'>
                <div className='single-speaker-area bg-gradient-overlay-2 wow fadeInUp' data-wow-delay='300ms'>
                  {/* <!-- Thumb --> */}
                  <div className='speaker-single-thumb'>
                    <img src='img/robochef-thanthi.png' alt='' />
                  </div>
                  {/* <!-- Info --> */}
                  <div className='speaker-info'>
                    <h5>Thanthi Tv</h5>
                    <p>Tv & Media</p>
                  </div>
                </div>
              </div>

              {/* <div className='col-12'>
                <div className='more-speaker-btn text-center mt-20 mb-40 wow fadeInUp' data-wow-delay='300ms'>
                  <a className='btn confer-btn-white' href='#'>view all Speaker <i className='zmdi zmdi-long-arrow-right' /></a>
                </div>
              </div> */}
            </div>
            
          
          </div>
        </section>
        {/* <!-- Our Speakings Area End --> */}
      </>
    )
  }
}

export default Gallery
